import { default as indexrbJjX0XlxVMeta } from "/var/www/salamis-front-2/pages/about/index.vue?macro=true";
import { default as _91slug_93CYFMZlUEDBMeta } from "/var/www/salamis-front-2/pages/blog/[slug].vue?macro=true";
import { default as indexG9MtvRTdUNMeta } from "/var/www/salamis-front-2/pages/blog/index.vue?macro=true";
import { default as indexiQ41ndZz98Meta } from "/var/www/salamis-front-2/pages/campaigns/index.vue?macro=true";
import { default as index8nbBf45j1pMeta } from "/var/www/salamis-front-2/pages/career/index.vue?macro=true";
import { default as indexPNBmc8lP7KMeta } from "/var/www/salamis-front-2/pages/concepts/index.vue?macro=true";
import { default as summermegEco07O4Meta } from "/var/www/salamis-front-2/pages/concepts/summer.vue?macro=true";
import { default as winterfEWBn6OLBAMeta } from "/var/www/salamis-front-2/pages/concepts/winter.vue?macro=true";
import { default as indexZUuVrGnz1fMeta } from "/var/www/salamis-front-2/pages/contact/[name]/index.vue?macro=true";
import { default as ContactFormuQ266aSbL4Meta } from "/var/www/salamis-front-2/pages/contact/components/ContactForm.vue?macro=true";
import { default as indexXpNZr3EWMyMeta } from "/var/www/salamis-front-2/pages/contact/index.vue?macro=true";
import { default as EventCalendarGSIbsvBfscMeta } from "/var/www/salamis-front-2/pages/events/components/EventCalendar.vue?macro=true";
import { default as EventCardsqeDNUkj03zMeta } from "/var/www/salamis-front-2/pages/events/components/EventCards.vue?macro=true";
import { default as EventCarouselx7DliqomzzMeta } from "/var/www/salamis-front-2/pages/events/components/EventCarousel.vue?macro=true";
import { default as WeeklyProgram1qE2snsjmmMeta } from "/var/www/salamis-front-2/pages/events/components/WeeklyProgram.vue?macro=true";
import { default as indexLbcEkjqMJzMeta } from "/var/www/salamis-front-2/pages/events/index.vue?macro=true";
import { default as _91slug_930HqYW9hq86Meta } from "/var/www/salamis-front-2/pages/events/meeting-halls/[slug].vue?macro=true";
import { default as indexmlXvDj66aMMeta } from "/var/www/salamis-front-2/pages/faqs/index.vue?macro=true";
import { default as _91id_93PpOmowdFucMeta } from "/var/www/salamis-front-2/pages/flavors/[id].vue?macro=true";
import { default as indexPmOCBSwxAJMeta } from "/var/www/salamis-front-2/pages/flavors/index.vue?macro=true";
import { default as indexJJi9xhjnbJMeta } from "/var/www/salamis-front-2/pages/gallery/index.vue?macro=true";
import { default as BarSection8YywIrViAQMeta } from "/var/www/salamis-front-2/pages/index_components/BarSection.vue?macro=true";
import { default as EventsSectionRJsAgllEwjMeta } from "/var/www/salamis-front-2/pages/index_components/EventsSection.vue?macro=true";
import { default as HeroSectionJJZxDYxvjVMeta } from "/var/www/salamis-front-2/pages/index_components/HeroSection.vue?macro=true";
import { default as LandingCarousel86qSG5lnhMMeta } from "/var/www/salamis-front-2/pages/index_components/LandingCarousel.vue?macro=true";
import { default as RestaurantSectionaW4MLewnqeMeta } from "/var/www/salamis-front-2/pages/index_components/RestaurantSection.vue?macro=true";
import { default as RoomSectionQcJFcoFnagMeta } from "/var/www/salamis-front-2/pages/index_components/RoomSection.vue?macro=true";
import { default as RoomSliderSectionP2VbUElG4iMeta } from "/var/www/salamis-front-2/pages/index_components/RoomSliderSection.vue?macro=true";
import { default as SpaBannerpidJX0955gMeta } from "/var/www/salamis-front-2/pages/index_components/SpaBanner.vue?macro=true";
import { default as SpaSectionb8ZUqtpfvGMeta } from "/var/www/salamis-front-2/pages/index_components/SpaSection.vue?macro=true";
import { default as indexBlWUnKCFL6Meta } from "/var/www/salamis-front-2/pages/index.vue?macro=true";
import { default as indexxziziC35veMeta } from "/var/www/salamis-front-2/pages/installment-options/index.vue?macro=true";
import { default as index6TjoCMZ19CMeta } from "/var/www/salamis-front-2/pages/mobile/index.vue?macro=true";
import { default as indexHbouGUhwjfMeta } from "/var/www/salamis-front-2/pages/policy/index.vue?macro=true";
import { default as indexUiQNJpvB8xMeta } from "/var/www/salamis-front-2/pages/quality/index.vue?macro=true";
import { default as indexCm0FTQ1h38Meta } from "/var/www/salamis-front-2/pages/refund/index.vue?macro=true";
import { default as _91slug_931jzgHItelNMeta } from "/var/www/salamis-front-2/pages/rooms/[slug].vue?macro=true";
import { default as index2wy64SbrvEMeta } from "/var/www/salamis-front-2/pages/rooms/index.vue?macro=true";
import { default as SpaCardslFFEhoo6lpMeta } from "/var/www/salamis-front-2/pages/spa/components/SpaCards.vue?macro=true";
import { default as indexMjgJH2Lm9pMeta } from "/var/www/salamis-front-2/pages/spa/index.vue?macro=true";
import { default as component_45stub5R9JdsTPRLMeta } from "/var/www/salamis-front-2/node_modules/nuxt/dist/pages/runtime/component-stub?macro=true";
export default [
  {
    name: indexrbJjX0XlxVMeta?.name ?? "about___tr",
    path: indexrbJjX0XlxVMeta?.path ?? "/about",
    meta: indexrbJjX0XlxVMeta || {},
    alias: indexrbJjX0XlxVMeta?.alias || [],
    redirect: indexrbJjX0XlxVMeta?.redirect,
    component: () => import("/var/www/salamis-front-2/pages/about/index.vue").then(m => m.default || m)
  },
  {
    name: indexrbJjX0XlxVMeta?.name ?? "about___en",
    path: indexrbJjX0XlxVMeta?.path ?? "/en/about",
    meta: indexrbJjX0XlxVMeta || {},
    alias: indexrbJjX0XlxVMeta?.alias || [],
    redirect: indexrbJjX0XlxVMeta?.redirect,
    component: () => import("/var/www/salamis-front-2/pages/about/index.vue").then(m => m.default || m)
  },
  {
    name: _91slug_93CYFMZlUEDBMeta?.name ?? "blog-slug___tr",
    path: _91slug_93CYFMZlUEDBMeta?.path ?? "/blog/:slug()",
    meta: _91slug_93CYFMZlUEDBMeta || {},
    alias: _91slug_93CYFMZlUEDBMeta?.alias || [],
    redirect: _91slug_93CYFMZlUEDBMeta?.redirect,
    component: () => import("/var/www/salamis-front-2/pages/blog/[slug].vue").then(m => m.default || m)
  },
  {
    name: _91slug_93CYFMZlUEDBMeta?.name ?? "blog-slug___en",
    path: _91slug_93CYFMZlUEDBMeta?.path ?? "/en/blog/:slug()",
    meta: _91slug_93CYFMZlUEDBMeta || {},
    alias: _91slug_93CYFMZlUEDBMeta?.alias || [],
    redirect: _91slug_93CYFMZlUEDBMeta?.redirect,
    component: () => import("/var/www/salamis-front-2/pages/blog/[slug].vue").then(m => m.default || m)
  },
  {
    name: indexG9MtvRTdUNMeta?.name ?? "blog___tr",
    path: indexG9MtvRTdUNMeta?.path ?? "/blog",
    meta: indexG9MtvRTdUNMeta || {},
    alias: indexG9MtvRTdUNMeta?.alias || [],
    redirect: indexG9MtvRTdUNMeta?.redirect,
    component: () => import("/var/www/salamis-front-2/pages/blog/index.vue").then(m => m.default || m)
  },
  {
    name: indexG9MtvRTdUNMeta?.name ?? "blog___en",
    path: indexG9MtvRTdUNMeta?.path ?? "/en/blog",
    meta: indexG9MtvRTdUNMeta || {},
    alias: indexG9MtvRTdUNMeta?.alias || [],
    redirect: indexG9MtvRTdUNMeta?.redirect,
    component: () => import("/var/www/salamis-front-2/pages/blog/index.vue").then(m => m.default || m)
  },
  {
    name: indexiQ41ndZz98Meta?.name ?? "campaigns___tr",
    path: indexiQ41ndZz98Meta?.path ?? "/campaigns",
    meta: indexiQ41ndZz98Meta || {},
    alias: indexiQ41ndZz98Meta?.alias || [],
    redirect: indexiQ41ndZz98Meta?.redirect,
    component: () => import("/var/www/salamis-front-2/pages/campaigns/index.vue").then(m => m.default || m)
  },
  {
    name: indexiQ41ndZz98Meta?.name ?? "campaigns___en",
    path: indexiQ41ndZz98Meta?.path ?? "/en/campaigns",
    meta: indexiQ41ndZz98Meta || {},
    alias: indexiQ41ndZz98Meta?.alias || [],
    redirect: indexiQ41ndZz98Meta?.redirect,
    component: () => import("/var/www/salamis-front-2/pages/campaigns/index.vue").then(m => m.default || m)
  },
  {
    name: index8nbBf45j1pMeta?.name ?? "career___tr",
    path: index8nbBf45j1pMeta?.path ?? "/career",
    meta: index8nbBf45j1pMeta || {},
    alias: index8nbBf45j1pMeta?.alias || [],
    redirect: index8nbBf45j1pMeta?.redirect,
    component: () => import("/var/www/salamis-front-2/pages/career/index.vue").then(m => m.default || m)
  },
  {
    name: index8nbBf45j1pMeta?.name ?? "career___en",
    path: index8nbBf45j1pMeta?.path ?? "/en/career",
    meta: index8nbBf45j1pMeta || {},
    alias: index8nbBf45j1pMeta?.alias || [],
    redirect: index8nbBf45j1pMeta?.redirect,
    component: () => import("/var/www/salamis-front-2/pages/career/index.vue").then(m => m.default || m)
  },
  {
    name: indexPNBmc8lP7KMeta?.name ?? "concepts___tr",
    path: indexPNBmc8lP7KMeta?.path ?? "/concepts",
    meta: indexPNBmc8lP7KMeta || {},
    alias: indexPNBmc8lP7KMeta?.alias || [],
    redirect: indexPNBmc8lP7KMeta?.redirect,
    component: () => import("/var/www/salamis-front-2/pages/concepts/index.vue").then(m => m.default || m)
  },
  {
    name: indexPNBmc8lP7KMeta?.name ?? "concepts___en",
    path: indexPNBmc8lP7KMeta?.path ?? "/en/concepts",
    meta: indexPNBmc8lP7KMeta || {},
    alias: indexPNBmc8lP7KMeta?.alias || [],
    redirect: indexPNBmc8lP7KMeta?.redirect,
    component: () => import("/var/www/salamis-front-2/pages/concepts/index.vue").then(m => m.default || m)
  },
  {
    name: summermegEco07O4Meta?.name ?? "concepts-summer___tr",
    path: summermegEco07O4Meta?.path ?? "/concepts/summer",
    meta: summermegEco07O4Meta || {},
    alias: summermegEco07O4Meta?.alias || [],
    redirect: summermegEco07O4Meta?.redirect,
    component: () => import("/var/www/salamis-front-2/pages/concepts/summer.vue").then(m => m.default || m)
  },
  {
    name: summermegEco07O4Meta?.name ?? "concepts-summer___en",
    path: summermegEco07O4Meta?.path ?? "/en/concepts/summer",
    meta: summermegEco07O4Meta || {},
    alias: summermegEco07O4Meta?.alias || [],
    redirect: summermegEco07O4Meta?.redirect,
    component: () => import("/var/www/salamis-front-2/pages/concepts/summer.vue").then(m => m.default || m)
  },
  {
    name: winterfEWBn6OLBAMeta?.name ?? "concepts-winter___tr",
    path: winterfEWBn6OLBAMeta?.path ?? "/concepts/winter",
    meta: winterfEWBn6OLBAMeta || {},
    alias: winterfEWBn6OLBAMeta?.alias || [],
    redirect: winterfEWBn6OLBAMeta?.redirect,
    component: () => import("/var/www/salamis-front-2/pages/concepts/winter.vue").then(m => m.default || m)
  },
  {
    name: winterfEWBn6OLBAMeta?.name ?? "concepts-winter___en",
    path: winterfEWBn6OLBAMeta?.path ?? "/en/concepts/winter",
    meta: winterfEWBn6OLBAMeta || {},
    alias: winterfEWBn6OLBAMeta?.alias || [],
    redirect: winterfEWBn6OLBAMeta?.redirect,
    component: () => import("/var/www/salamis-front-2/pages/concepts/winter.vue").then(m => m.default || m)
  },
  {
    name: indexZUuVrGnz1fMeta?.name ?? "contact-name___tr",
    path: indexZUuVrGnz1fMeta?.path ?? "/contact/:name()",
    meta: indexZUuVrGnz1fMeta || {},
    alias: indexZUuVrGnz1fMeta?.alias || [],
    redirect: indexZUuVrGnz1fMeta?.redirect,
    component: () => import("/var/www/salamis-front-2/pages/contact/[name]/index.vue").then(m => m.default || m)
  },
  {
    name: indexZUuVrGnz1fMeta?.name ?? "contact-name___en",
    path: indexZUuVrGnz1fMeta?.path ?? "/en/contact/:name()",
    meta: indexZUuVrGnz1fMeta || {},
    alias: indexZUuVrGnz1fMeta?.alias || [],
    redirect: indexZUuVrGnz1fMeta?.redirect,
    component: () => import("/var/www/salamis-front-2/pages/contact/[name]/index.vue").then(m => m.default || m)
  },
  {
    name: ContactFormuQ266aSbL4Meta?.name ?? "contact-components-ContactForm___tr",
    path: ContactFormuQ266aSbL4Meta?.path ?? "/contact/components/ContactForm",
    meta: ContactFormuQ266aSbL4Meta || {},
    alias: ContactFormuQ266aSbL4Meta?.alias || [],
    redirect: ContactFormuQ266aSbL4Meta?.redirect,
    component: () => import("/var/www/salamis-front-2/pages/contact/components/ContactForm.vue").then(m => m.default || m)
  },
  {
    name: ContactFormuQ266aSbL4Meta?.name ?? "contact-components-ContactForm___en",
    path: ContactFormuQ266aSbL4Meta?.path ?? "/en/contact/components/ContactForm",
    meta: ContactFormuQ266aSbL4Meta || {},
    alias: ContactFormuQ266aSbL4Meta?.alias || [],
    redirect: ContactFormuQ266aSbL4Meta?.redirect,
    component: () => import("/var/www/salamis-front-2/pages/contact/components/ContactForm.vue").then(m => m.default || m)
  },
  {
    name: indexXpNZr3EWMyMeta?.name ?? "contact___tr",
    path: indexXpNZr3EWMyMeta?.path ?? "/contact",
    meta: indexXpNZr3EWMyMeta || {},
    alias: indexXpNZr3EWMyMeta?.alias || [],
    redirect: indexXpNZr3EWMyMeta?.redirect,
    component: () => import("/var/www/salamis-front-2/pages/contact/index.vue").then(m => m.default || m)
  },
  {
    name: indexXpNZr3EWMyMeta?.name ?? "contact___en",
    path: indexXpNZr3EWMyMeta?.path ?? "/en/contact",
    meta: indexXpNZr3EWMyMeta || {},
    alias: indexXpNZr3EWMyMeta?.alias || [],
    redirect: indexXpNZr3EWMyMeta?.redirect,
    component: () => import("/var/www/salamis-front-2/pages/contact/index.vue").then(m => m.default || m)
  },
  {
    name: EventCalendarGSIbsvBfscMeta?.name ?? "events-components-EventCalendar___tr",
    path: EventCalendarGSIbsvBfscMeta?.path ?? "/events/components/EventCalendar",
    meta: EventCalendarGSIbsvBfscMeta || {},
    alias: EventCalendarGSIbsvBfscMeta?.alias || [],
    redirect: EventCalendarGSIbsvBfscMeta?.redirect,
    component: () => import("/var/www/salamis-front-2/pages/events/components/EventCalendar.vue").then(m => m.default || m)
  },
  {
    name: EventCalendarGSIbsvBfscMeta?.name ?? "events-components-EventCalendar___en",
    path: EventCalendarGSIbsvBfscMeta?.path ?? "/en/events/components/EventCalendar",
    meta: EventCalendarGSIbsvBfscMeta || {},
    alias: EventCalendarGSIbsvBfscMeta?.alias || [],
    redirect: EventCalendarGSIbsvBfscMeta?.redirect,
    component: () => import("/var/www/salamis-front-2/pages/events/components/EventCalendar.vue").then(m => m.default || m)
  },
  {
    name: EventCardsqeDNUkj03zMeta?.name ?? "events-components-EventCards___tr",
    path: EventCardsqeDNUkj03zMeta?.path ?? "/events/components/EventCards",
    meta: EventCardsqeDNUkj03zMeta || {},
    alias: EventCardsqeDNUkj03zMeta?.alias || [],
    redirect: EventCardsqeDNUkj03zMeta?.redirect,
    component: () => import("/var/www/salamis-front-2/pages/events/components/EventCards.vue").then(m => m.default || m)
  },
  {
    name: EventCardsqeDNUkj03zMeta?.name ?? "events-components-EventCards___en",
    path: EventCardsqeDNUkj03zMeta?.path ?? "/en/events/components/EventCards",
    meta: EventCardsqeDNUkj03zMeta || {},
    alias: EventCardsqeDNUkj03zMeta?.alias || [],
    redirect: EventCardsqeDNUkj03zMeta?.redirect,
    component: () => import("/var/www/salamis-front-2/pages/events/components/EventCards.vue").then(m => m.default || m)
  },
  {
    name: EventCarouselx7DliqomzzMeta?.name ?? "events-components-EventCarousel___tr",
    path: EventCarouselx7DliqomzzMeta?.path ?? "/events/components/EventCarousel",
    meta: EventCarouselx7DliqomzzMeta || {},
    alias: EventCarouselx7DliqomzzMeta?.alias || [],
    redirect: EventCarouselx7DliqomzzMeta?.redirect,
    component: () => import("/var/www/salamis-front-2/pages/events/components/EventCarousel.vue").then(m => m.default || m)
  },
  {
    name: EventCarouselx7DliqomzzMeta?.name ?? "events-components-EventCarousel___en",
    path: EventCarouselx7DliqomzzMeta?.path ?? "/en/events/components/EventCarousel",
    meta: EventCarouselx7DliqomzzMeta || {},
    alias: EventCarouselx7DliqomzzMeta?.alias || [],
    redirect: EventCarouselx7DliqomzzMeta?.redirect,
    component: () => import("/var/www/salamis-front-2/pages/events/components/EventCarousel.vue").then(m => m.default || m)
  },
  {
    name: WeeklyProgram1qE2snsjmmMeta?.name ?? "events-components-WeeklyProgram___tr",
    path: WeeklyProgram1qE2snsjmmMeta?.path ?? "/events/components/WeeklyProgram",
    meta: WeeklyProgram1qE2snsjmmMeta || {},
    alias: WeeklyProgram1qE2snsjmmMeta?.alias || [],
    redirect: WeeklyProgram1qE2snsjmmMeta?.redirect,
    component: () => import("/var/www/salamis-front-2/pages/events/components/WeeklyProgram.vue").then(m => m.default || m)
  },
  {
    name: WeeklyProgram1qE2snsjmmMeta?.name ?? "events-components-WeeklyProgram___en",
    path: WeeklyProgram1qE2snsjmmMeta?.path ?? "/en/events/components/WeeklyProgram",
    meta: WeeklyProgram1qE2snsjmmMeta || {},
    alias: WeeklyProgram1qE2snsjmmMeta?.alias || [],
    redirect: WeeklyProgram1qE2snsjmmMeta?.redirect,
    component: () => import("/var/www/salamis-front-2/pages/events/components/WeeklyProgram.vue").then(m => m.default || m)
  },
  {
    name: indexLbcEkjqMJzMeta?.name ?? "events___tr",
    path: indexLbcEkjqMJzMeta?.path ?? "/events",
    meta: indexLbcEkjqMJzMeta || {},
    alias: indexLbcEkjqMJzMeta?.alias || [],
    redirect: indexLbcEkjqMJzMeta?.redirect,
    component: () => import("/var/www/salamis-front-2/pages/events/index.vue").then(m => m.default || m)
  },
  {
    name: indexLbcEkjqMJzMeta?.name ?? "events___en",
    path: indexLbcEkjqMJzMeta?.path ?? "/en/events",
    meta: indexLbcEkjqMJzMeta || {},
    alias: indexLbcEkjqMJzMeta?.alias || [],
    redirect: indexLbcEkjqMJzMeta?.redirect,
    component: () => import("/var/www/salamis-front-2/pages/events/index.vue").then(m => m.default || m)
  },
  {
    name: _91slug_930HqYW9hq86Meta?.name ?? "events-meeting-halls-slug___tr",
    path: _91slug_930HqYW9hq86Meta?.path ?? "/events/meeting-halls/:slug()",
    meta: _91slug_930HqYW9hq86Meta || {},
    alias: _91slug_930HqYW9hq86Meta?.alias || [],
    redirect: _91slug_930HqYW9hq86Meta?.redirect,
    component: () => import("/var/www/salamis-front-2/pages/events/meeting-halls/[slug].vue").then(m => m.default || m)
  },
  {
    name: _91slug_930HqYW9hq86Meta?.name ?? "events-meeting-halls-slug___en",
    path: _91slug_930HqYW9hq86Meta?.path ?? "/en/events/meeting-halls/:slug()",
    meta: _91slug_930HqYW9hq86Meta || {},
    alias: _91slug_930HqYW9hq86Meta?.alias || [],
    redirect: _91slug_930HqYW9hq86Meta?.redirect,
    component: () => import("/var/www/salamis-front-2/pages/events/meeting-halls/[slug].vue").then(m => m.default || m)
  },
  {
    name: indexmlXvDj66aMMeta?.name ?? "faqs___tr",
    path: indexmlXvDj66aMMeta?.path ?? "/faqs",
    meta: indexmlXvDj66aMMeta || {},
    alias: indexmlXvDj66aMMeta?.alias || [],
    redirect: indexmlXvDj66aMMeta?.redirect,
    component: () => import("/var/www/salamis-front-2/pages/faqs/index.vue").then(m => m.default || m)
  },
  {
    name: indexmlXvDj66aMMeta?.name ?? "faqs___en",
    path: indexmlXvDj66aMMeta?.path ?? "/en/faqs",
    meta: indexmlXvDj66aMMeta || {},
    alias: indexmlXvDj66aMMeta?.alias || [],
    redirect: indexmlXvDj66aMMeta?.redirect,
    component: () => import("/var/www/salamis-front-2/pages/faqs/index.vue").then(m => m.default || m)
  },
  {
    name: _91id_93PpOmowdFucMeta?.name ?? "flavors-id___tr",
    path: _91id_93PpOmowdFucMeta?.path ?? "/flavors/:id()",
    meta: _91id_93PpOmowdFucMeta || {},
    alias: _91id_93PpOmowdFucMeta?.alias || [],
    redirect: _91id_93PpOmowdFucMeta?.redirect,
    component: () => import("/var/www/salamis-front-2/pages/flavors/[id].vue").then(m => m.default || m)
  },
  {
    name: _91id_93PpOmowdFucMeta?.name ?? "flavors-id___en",
    path: _91id_93PpOmowdFucMeta?.path ?? "/en/flavors/:id()",
    meta: _91id_93PpOmowdFucMeta || {},
    alias: _91id_93PpOmowdFucMeta?.alias || [],
    redirect: _91id_93PpOmowdFucMeta?.redirect,
    component: () => import("/var/www/salamis-front-2/pages/flavors/[id].vue").then(m => m.default || m)
  },
  {
    name: indexPmOCBSwxAJMeta?.name ?? "flavors___tr",
    path: indexPmOCBSwxAJMeta?.path ?? "/flavors",
    meta: indexPmOCBSwxAJMeta || {},
    alias: indexPmOCBSwxAJMeta?.alias || [],
    redirect: indexPmOCBSwxAJMeta?.redirect,
    component: () => import("/var/www/salamis-front-2/pages/flavors/index.vue").then(m => m.default || m)
  },
  {
    name: indexPmOCBSwxAJMeta?.name ?? "flavors___en",
    path: indexPmOCBSwxAJMeta?.path ?? "/en/flavors",
    meta: indexPmOCBSwxAJMeta || {},
    alias: indexPmOCBSwxAJMeta?.alias || [],
    redirect: indexPmOCBSwxAJMeta?.redirect,
    component: () => import("/var/www/salamis-front-2/pages/flavors/index.vue").then(m => m.default || m)
  },
  {
    name: indexJJi9xhjnbJMeta?.name ?? "gallery___tr",
    path: indexJJi9xhjnbJMeta?.path ?? "/gallery",
    meta: indexJJi9xhjnbJMeta || {},
    alias: indexJJi9xhjnbJMeta?.alias || [],
    redirect: indexJJi9xhjnbJMeta?.redirect,
    component: () => import("/var/www/salamis-front-2/pages/gallery/index.vue").then(m => m.default || m)
  },
  {
    name: indexJJi9xhjnbJMeta?.name ?? "gallery___en",
    path: indexJJi9xhjnbJMeta?.path ?? "/en/gallery",
    meta: indexJJi9xhjnbJMeta || {},
    alias: indexJJi9xhjnbJMeta?.alias || [],
    redirect: indexJJi9xhjnbJMeta?.redirect,
    component: () => import("/var/www/salamis-front-2/pages/gallery/index.vue").then(m => m.default || m)
  },
  {
    name: BarSection8YywIrViAQMeta?.name ?? "index_components-BarSection___tr",
    path: BarSection8YywIrViAQMeta?.path ?? "/index_components/BarSection",
    meta: BarSection8YywIrViAQMeta || {},
    alias: BarSection8YywIrViAQMeta?.alias || [],
    redirect: BarSection8YywIrViAQMeta?.redirect,
    component: () => import("/var/www/salamis-front-2/pages/index_components/BarSection.vue").then(m => m.default || m)
  },
  {
    name: BarSection8YywIrViAQMeta?.name ?? "index_components-BarSection___en",
    path: BarSection8YywIrViAQMeta?.path ?? "/en/index_components/BarSection",
    meta: BarSection8YywIrViAQMeta || {},
    alias: BarSection8YywIrViAQMeta?.alias || [],
    redirect: BarSection8YywIrViAQMeta?.redirect,
    component: () => import("/var/www/salamis-front-2/pages/index_components/BarSection.vue").then(m => m.default || m)
  },
  {
    name: EventsSectionRJsAgllEwjMeta?.name ?? "index_components-EventsSection___tr",
    path: EventsSectionRJsAgllEwjMeta?.path ?? "/index_components/EventsSection",
    meta: EventsSectionRJsAgllEwjMeta || {},
    alias: EventsSectionRJsAgllEwjMeta?.alias || [],
    redirect: EventsSectionRJsAgllEwjMeta?.redirect,
    component: () => import("/var/www/salamis-front-2/pages/index_components/EventsSection.vue").then(m => m.default || m)
  },
  {
    name: EventsSectionRJsAgllEwjMeta?.name ?? "index_components-EventsSection___en",
    path: EventsSectionRJsAgllEwjMeta?.path ?? "/en/index_components/EventsSection",
    meta: EventsSectionRJsAgllEwjMeta || {},
    alias: EventsSectionRJsAgllEwjMeta?.alias || [],
    redirect: EventsSectionRJsAgllEwjMeta?.redirect,
    component: () => import("/var/www/salamis-front-2/pages/index_components/EventsSection.vue").then(m => m.default || m)
  },
  {
    name: HeroSectionJJZxDYxvjVMeta?.name ?? "index_components-HeroSection___tr",
    path: HeroSectionJJZxDYxvjVMeta?.path ?? "/index_components/HeroSection",
    meta: HeroSectionJJZxDYxvjVMeta || {},
    alias: HeroSectionJJZxDYxvjVMeta?.alias || [],
    redirect: HeroSectionJJZxDYxvjVMeta?.redirect,
    component: () => import("/var/www/salamis-front-2/pages/index_components/HeroSection.vue").then(m => m.default || m)
  },
  {
    name: HeroSectionJJZxDYxvjVMeta?.name ?? "index_components-HeroSection___en",
    path: HeroSectionJJZxDYxvjVMeta?.path ?? "/en/index_components/HeroSection",
    meta: HeroSectionJJZxDYxvjVMeta || {},
    alias: HeroSectionJJZxDYxvjVMeta?.alias || [],
    redirect: HeroSectionJJZxDYxvjVMeta?.redirect,
    component: () => import("/var/www/salamis-front-2/pages/index_components/HeroSection.vue").then(m => m.default || m)
  },
  {
    name: LandingCarousel86qSG5lnhMMeta?.name ?? "index_components-LandingCarousel___tr",
    path: LandingCarousel86qSG5lnhMMeta?.path ?? "/index_components/LandingCarousel",
    meta: LandingCarousel86qSG5lnhMMeta || {},
    alias: LandingCarousel86qSG5lnhMMeta?.alias || [],
    redirect: LandingCarousel86qSG5lnhMMeta?.redirect,
    component: () => import("/var/www/salamis-front-2/pages/index_components/LandingCarousel.vue").then(m => m.default || m)
  },
  {
    name: LandingCarousel86qSG5lnhMMeta?.name ?? "index_components-LandingCarousel___en",
    path: LandingCarousel86qSG5lnhMMeta?.path ?? "/en/index_components/LandingCarousel",
    meta: LandingCarousel86qSG5lnhMMeta || {},
    alias: LandingCarousel86qSG5lnhMMeta?.alias || [],
    redirect: LandingCarousel86qSG5lnhMMeta?.redirect,
    component: () => import("/var/www/salamis-front-2/pages/index_components/LandingCarousel.vue").then(m => m.default || m)
  },
  {
    name: RestaurantSectionaW4MLewnqeMeta?.name ?? "index_components-RestaurantSection___tr",
    path: RestaurantSectionaW4MLewnqeMeta?.path ?? "/index_components/RestaurantSection",
    meta: RestaurantSectionaW4MLewnqeMeta || {},
    alias: RestaurantSectionaW4MLewnqeMeta?.alias || [],
    redirect: RestaurantSectionaW4MLewnqeMeta?.redirect,
    component: () => import("/var/www/salamis-front-2/pages/index_components/RestaurantSection.vue").then(m => m.default || m)
  },
  {
    name: RestaurantSectionaW4MLewnqeMeta?.name ?? "index_components-RestaurantSection___en",
    path: RestaurantSectionaW4MLewnqeMeta?.path ?? "/en/index_components/RestaurantSection",
    meta: RestaurantSectionaW4MLewnqeMeta || {},
    alias: RestaurantSectionaW4MLewnqeMeta?.alias || [],
    redirect: RestaurantSectionaW4MLewnqeMeta?.redirect,
    component: () => import("/var/www/salamis-front-2/pages/index_components/RestaurantSection.vue").then(m => m.default || m)
  },
  {
    name: RoomSectionQcJFcoFnagMeta?.name ?? "index_components-RoomSection___tr",
    path: RoomSectionQcJFcoFnagMeta?.path ?? "/index_components/RoomSection",
    meta: RoomSectionQcJFcoFnagMeta || {},
    alias: RoomSectionQcJFcoFnagMeta?.alias || [],
    redirect: RoomSectionQcJFcoFnagMeta?.redirect,
    component: () => import("/var/www/salamis-front-2/pages/index_components/RoomSection.vue").then(m => m.default || m)
  },
  {
    name: RoomSectionQcJFcoFnagMeta?.name ?? "index_components-RoomSection___en",
    path: RoomSectionQcJFcoFnagMeta?.path ?? "/en/index_components/RoomSection",
    meta: RoomSectionQcJFcoFnagMeta || {},
    alias: RoomSectionQcJFcoFnagMeta?.alias || [],
    redirect: RoomSectionQcJFcoFnagMeta?.redirect,
    component: () => import("/var/www/salamis-front-2/pages/index_components/RoomSection.vue").then(m => m.default || m)
  },
  {
    name: RoomSliderSectionP2VbUElG4iMeta?.name ?? "index_components-RoomSliderSection___tr",
    path: RoomSliderSectionP2VbUElG4iMeta?.path ?? "/index_components/RoomSliderSection",
    meta: RoomSliderSectionP2VbUElG4iMeta || {},
    alias: RoomSliderSectionP2VbUElG4iMeta?.alias || [],
    redirect: RoomSliderSectionP2VbUElG4iMeta?.redirect,
    component: () => import("/var/www/salamis-front-2/pages/index_components/RoomSliderSection.vue").then(m => m.default || m)
  },
  {
    name: RoomSliderSectionP2VbUElG4iMeta?.name ?? "index_components-RoomSliderSection___en",
    path: RoomSliderSectionP2VbUElG4iMeta?.path ?? "/en/index_components/RoomSliderSection",
    meta: RoomSliderSectionP2VbUElG4iMeta || {},
    alias: RoomSliderSectionP2VbUElG4iMeta?.alias || [],
    redirect: RoomSliderSectionP2VbUElG4iMeta?.redirect,
    component: () => import("/var/www/salamis-front-2/pages/index_components/RoomSliderSection.vue").then(m => m.default || m)
  },
  {
    name: SpaBannerpidJX0955gMeta?.name ?? "index_components-SpaBanner___tr",
    path: SpaBannerpidJX0955gMeta?.path ?? "/index_components/SpaBanner",
    meta: SpaBannerpidJX0955gMeta || {},
    alias: SpaBannerpidJX0955gMeta?.alias || [],
    redirect: SpaBannerpidJX0955gMeta?.redirect,
    component: () => import("/var/www/salamis-front-2/pages/index_components/SpaBanner.vue").then(m => m.default || m)
  },
  {
    name: SpaBannerpidJX0955gMeta?.name ?? "index_components-SpaBanner___en",
    path: SpaBannerpidJX0955gMeta?.path ?? "/en/index_components/SpaBanner",
    meta: SpaBannerpidJX0955gMeta || {},
    alias: SpaBannerpidJX0955gMeta?.alias || [],
    redirect: SpaBannerpidJX0955gMeta?.redirect,
    component: () => import("/var/www/salamis-front-2/pages/index_components/SpaBanner.vue").then(m => m.default || m)
  },
  {
    name: SpaSectionb8ZUqtpfvGMeta?.name ?? "index_components-SpaSection___tr",
    path: SpaSectionb8ZUqtpfvGMeta?.path ?? "/index_components/SpaSection",
    meta: SpaSectionb8ZUqtpfvGMeta || {},
    alias: SpaSectionb8ZUqtpfvGMeta?.alias || [],
    redirect: SpaSectionb8ZUqtpfvGMeta?.redirect,
    component: () => import("/var/www/salamis-front-2/pages/index_components/SpaSection.vue").then(m => m.default || m)
  },
  {
    name: SpaSectionb8ZUqtpfvGMeta?.name ?? "index_components-SpaSection___en",
    path: SpaSectionb8ZUqtpfvGMeta?.path ?? "/en/index_components/SpaSection",
    meta: SpaSectionb8ZUqtpfvGMeta || {},
    alias: SpaSectionb8ZUqtpfvGMeta?.alias || [],
    redirect: SpaSectionb8ZUqtpfvGMeta?.redirect,
    component: () => import("/var/www/salamis-front-2/pages/index_components/SpaSection.vue").then(m => m.default || m)
  },
  {
    name: indexBlWUnKCFL6Meta?.name ?? "index___tr",
    path: indexBlWUnKCFL6Meta?.path ?? "/",
    meta: indexBlWUnKCFL6Meta || {},
    alias: indexBlWUnKCFL6Meta?.alias || [],
    redirect: indexBlWUnKCFL6Meta?.redirect,
    component: () => import("/var/www/salamis-front-2/pages/index.vue").then(m => m.default || m)
  },
  {
    name: indexBlWUnKCFL6Meta?.name ?? "index___en",
    path: indexBlWUnKCFL6Meta?.path ?? "/en",
    meta: indexBlWUnKCFL6Meta || {},
    alias: indexBlWUnKCFL6Meta?.alias || [],
    redirect: indexBlWUnKCFL6Meta?.redirect,
    component: () => import("/var/www/salamis-front-2/pages/index.vue").then(m => m.default || m)
  },
  {
    name: indexxziziC35veMeta?.name ?? "installment-options___tr",
    path: indexxziziC35veMeta?.path ?? "/installment-options",
    meta: indexxziziC35veMeta || {},
    alias: indexxziziC35veMeta?.alias || [],
    redirect: indexxziziC35veMeta?.redirect,
    component: () => import("/var/www/salamis-front-2/pages/installment-options/index.vue").then(m => m.default || m)
  },
  {
    name: indexxziziC35veMeta?.name ?? "installment-options___en",
    path: indexxziziC35veMeta?.path ?? "/en/installment-options",
    meta: indexxziziC35veMeta || {},
    alias: indexxziziC35veMeta?.alias || [],
    redirect: indexxziziC35veMeta?.redirect,
    component: () => import("/var/www/salamis-front-2/pages/installment-options/index.vue").then(m => m.default || m)
  },
  {
    name: index6TjoCMZ19CMeta?.name ?? "mobile___tr",
    path: index6TjoCMZ19CMeta?.path ?? "/mobile",
    meta: index6TjoCMZ19CMeta || {},
    alias: index6TjoCMZ19CMeta?.alias || [],
    redirect: index6TjoCMZ19CMeta?.redirect,
    component: () => import("/var/www/salamis-front-2/pages/mobile/index.vue").then(m => m.default || m)
  },
  {
    name: index6TjoCMZ19CMeta?.name ?? "mobile___en",
    path: index6TjoCMZ19CMeta?.path ?? "/en/mobile",
    meta: index6TjoCMZ19CMeta || {},
    alias: index6TjoCMZ19CMeta?.alias || [],
    redirect: index6TjoCMZ19CMeta?.redirect,
    component: () => import("/var/www/salamis-front-2/pages/mobile/index.vue").then(m => m.default || m)
  },
  {
    name: indexHbouGUhwjfMeta?.name ?? "policy___tr",
    path: indexHbouGUhwjfMeta?.path ?? "/policy",
    meta: indexHbouGUhwjfMeta || {},
    alias: indexHbouGUhwjfMeta?.alias || [],
    redirect: indexHbouGUhwjfMeta?.redirect,
    component: () => import("/var/www/salamis-front-2/pages/policy/index.vue").then(m => m.default || m)
  },
  {
    name: indexHbouGUhwjfMeta?.name ?? "policy___en",
    path: indexHbouGUhwjfMeta?.path ?? "/en/policy",
    meta: indexHbouGUhwjfMeta || {},
    alias: indexHbouGUhwjfMeta?.alias || [],
    redirect: indexHbouGUhwjfMeta?.redirect,
    component: () => import("/var/www/salamis-front-2/pages/policy/index.vue").then(m => m.default || m)
  },
  {
    name: indexUiQNJpvB8xMeta?.name ?? "quality___tr",
    path: indexUiQNJpvB8xMeta?.path ?? "/quality",
    meta: indexUiQNJpvB8xMeta || {},
    alias: indexUiQNJpvB8xMeta?.alias || [],
    redirect: indexUiQNJpvB8xMeta?.redirect,
    component: () => import("/var/www/salamis-front-2/pages/quality/index.vue").then(m => m.default || m)
  },
  {
    name: indexUiQNJpvB8xMeta?.name ?? "quality___en",
    path: indexUiQNJpvB8xMeta?.path ?? "/en/quality",
    meta: indexUiQNJpvB8xMeta || {},
    alias: indexUiQNJpvB8xMeta?.alias || [],
    redirect: indexUiQNJpvB8xMeta?.redirect,
    component: () => import("/var/www/salamis-front-2/pages/quality/index.vue").then(m => m.default || m)
  },
  {
    name: indexCm0FTQ1h38Meta?.name ?? "refund___tr",
    path: indexCm0FTQ1h38Meta?.path ?? "/refund",
    meta: indexCm0FTQ1h38Meta || {},
    alias: indexCm0FTQ1h38Meta?.alias || [],
    redirect: indexCm0FTQ1h38Meta?.redirect,
    component: () => import("/var/www/salamis-front-2/pages/refund/index.vue").then(m => m.default || m)
  },
  {
    name: indexCm0FTQ1h38Meta?.name ?? "refund___en",
    path: indexCm0FTQ1h38Meta?.path ?? "/en/refund",
    meta: indexCm0FTQ1h38Meta || {},
    alias: indexCm0FTQ1h38Meta?.alias || [],
    redirect: indexCm0FTQ1h38Meta?.redirect,
    component: () => import("/var/www/salamis-front-2/pages/refund/index.vue").then(m => m.default || m)
  },
  {
    name: _91slug_931jzgHItelNMeta?.name ?? "rooms-slug___tr",
    path: _91slug_931jzgHItelNMeta?.path ?? "/rooms/:slug()",
    meta: _91slug_931jzgHItelNMeta || {},
    alias: _91slug_931jzgHItelNMeta?.alias || [],
    redirect: _91slug_931jzgHItelNMeta?.redirect,
    component: () => import("/var/www/salamis-front-2/pages/rooms/[slug].vue").then(m => m.default || m)
  },
  {
    name: _91slug_931jzgHItelNMeta?.name ?? "rooms-slug___en",
    path: _91slug_931jzgHItelNMeta?.path ?? "/en/rooms/:slug()",
    meta: _91slug_931jzgHItelNMeta || {},
    alias: _91slug_931jzgHItelNMeta?.alias || [],
    redirect: _91slug_931jzgHItelNMeta?.redirect,
    component: () => import("/var/www/salamis-front-2/pages/rooms/[slug].vue").then(m => m.default || m)
  },
  {
    name: index2wy64SbrvEMeta?.name ?? "rooms___tr",
    path: index2wy64SbrvEMeta?.path ?? "/rooms",
    meta: index2wy64SbrvEMeta || {},
    alias: index2wy64SbrvEMeta?.alias || [],
    redirect: index2wy64SbrvEMeta?.redirect,
    component: () => import("/var/www/salamis-front-2/pages/rooms/index.vue").then(m => m.default || m)
  },
  {
    name: index2wy64SbrvEMeta?.name ?? "rooms___en",
    path: index2wy64SbrvEMeta?.path ?? "/en/rooms",
    meta: index2wy64SbrvEMeta || {},
    alias: index2wy64SbrvEMeta?.alias || [],
    redirect: index2wy64SbrvEMeta?.redirect,
    component: () => import("/var/www/salamis-front-2/pages/rooms/index.vue").then(m => m.default || m)
  },
  {
    name: SpaCardslFFEhoo6lpMeta?.name ?? "spa-components-SpaCards___tr",
    path: SpaCardslFFEhoo6lpMeta?.path ?? "/spa/components/SpaCards",
    meta: SpaCardslFFEhoo6lpMeta || {},
    alias: SpaCardslFFEhoo6lpMeta?.alias || [],
    redirect: SpaCardslFFEhoo6lpMeta?.redirect,
    component: () => import("/var/www/salamis-front-2/pages/spa/components/SpaCards.vue").then(m => m.default || m)
  },
  {
    name: SpaCardslFFEhoo6lpMeta?.name ?? "spa-components-SpaCards___en",
    path: SpaCardslFFEhoo6lpMeta?.path ?? "/en/spa/components/SpaCards",
    meta: SpaCardslFFEhoo6lpMeta || {},
    alias: SpaCardslFFEhoo6lpMeta?.alias || [],
    redirect: SpaCardslFFEhoo6lpMeta?.redirect,
    component: () => import("/var/www/salamis-front-2/pages/spa/components/SpaCards.vue").then(m => m.default || m)
  },
  {
    name: indexMjgJH2Lm9pMeta?.name ?? "spa___tr",
    path: indexMjgJH2Lm9pMeta?.path ?? "/spa",
    meta: indexMjgJH2Lm9pMeta || {},
    alias: indexMjgJH2Lm9pMeta?.alias || [],
    redirect: indexMjgJH2Lm9pMeta?.redirect,
    component: () => import("/var/www/salamis-front-2/pages/spa/index.vue").then(m => m.default || m)
  },
  {
    name: indexMjgJH2Lm9pMeta?.name ?? "spa___en",
    path: indexMjgJH2Lm9pMeta?.path ?? "/en/spa",
    meta: indexMjgJH2Lm9pMeta || {},
    alias: indexMjgJH2Lm9pMeta?.alias || [],
    redirect: indexMjgJH2Lm9pMeta?.redirect,
    component: () => import("/var/www/salamis-front-2/pages/spa/index.vue").then(m => m.default || m)
  },
  {
    name: component_45stub5R9JdsTPRLMeta?.name ?? undefined,
    path: component_45stub5R9JdsTPRLMeta?.path ?? "/en/christmas-swimming-event/blog_monalisa_hotel_theme_04/",
    meta: component_45stub5R9JdsTPRLMeta || {},
    alias: component_45stub5R9JdsTPRLMeta?.alias || [],
    redirect: component_45stub5R9JdsTPRLMeta?.redirect,
    component: () => import("/var/www/salamis-front-2/node_modules/nuxt/dist/pages/runtime/component-stub").then(m => m.default || m)
  },
  {
    name: component_45stub5R9JdsTPRLMeta?.name ?? undefined,
    path: component_45stub5R9JdsTPRLMeta?.path ?? "/en/christmas-swimming-event/blog_monalisa_hotel_theme_04",
    meta: component_45stub5R9JdsTPRLMeta || {},
    alias: component_45stub5R9JdsTPRLMeta?.alias || [],
    redirect: component_45stub5R9JdsTPRLMeta?.redirect,
    component: () => import("/var/www/salamis-front-2/node_modules/nuxt/dist/pages/runtime/component-stub").then(m => m.default || m)
  },
  {
    name: component_45stub5R9JdsTPRLMeta?.name ?? undefined,
    path: component_45stub5R9JdsTPRLMeta?.path ?? "/en/15-february-valentines-premiere/",
    meta: component_45stub5R9JdsTPRLMeta || {},
    alias: component_45stub5R9JdsTPRLMeta?.alias || [],
    redirect: component_45stub5R9JdsTPRLMeta?.redirect,
    component: () => import("/var/www/salamis-front-2/node_modules/nuxt/dist/pages/runtime/component-stub").then(m => m.default || m)
  },
  {
    name: component_45stub5R9JdsTPRLMeta?.name ?? undefined,
    path: component_45stub5R9JdsTPRLMeta?.path ?? "/en/15-february-valentines-premiere",
    meta: component_45stub5R9JdsTPRLMeta || {},
    alias: component_45stub5R9JdsTPRLMeta?.alias || [],
    redirect: component_45stub5R9JdsTPRLMeta?.redirect,
    component: () => import("/var/www/salamis-front-2/node_modules/nuxt/dist/pages/runtime/component-stub").then(m => m.default || m)
  },
  {
    name: component_45stub5R9JdsTPRLMeta?.name ?? undefined,
    path: component_45stub5R9JdsTPRLMeta?.path ?? "/en/christmas-swimming-event/",
    meta: component_45stub5R9JdsTPRLMeta || {},
    alias: component_45stub5R9JdsTPRLMeta?.alias || [],
    redirect: component_45stub5R9JdsTPRLMeta?.redirect,
    component: () => import("/var/www/salamis-front-2/node_modules/nuxt/dist/pages/runtime/component-stub").then(m => m.default || m)
  },
  {
    name: component_45stub5R9JdsTPRLMeta?.name ?? undefined,
    path: component_45stub5R9JdsTPRLMeta?.path ?? "/en/christmas-swimming-event",
    meta: component_45stub5R9JdsTPRLMeta || {},
    alias: component_45stub5R9JdsTPRLMeta?.alias || [],
    redirect: component_45stub5R9JdsTPRLMeta?.redirect,
    component: () => import("/var/www/salamis-front-2/node_modules/nuxt/dist/pages/runtime/component-stub").then(m => m.default || m)
  },
  {
    name: component_45stub5R9JdsTPRLMeta?.name ?? undefined,
    path: component_45stub5R9JdsTPRLMeta?.path ?? "/en/umit-sayin/",
    meta: component_45stub5R9JdsTPRLMeta || {},
    alias: component_45stub5R9JdsTPRLMeta?.alias || [],
    redirect: component_45stub5R9JdsTPRLMeta?.redirect,
    component: () => import("/var/www/salamis-front-2/node_modules/nuxt/dist/pages/runtime/component-stub").then(m => m.default || m)
  },
  {
    name: component_45stub5R9JdsTPRLMeta?.name ?? undefined,
    path: component_45stub5R9JdsTPRLMeta?.path ?? "/en/umit-sayin",
    meta: component_45stub5R9JdsTPRLMeta || {},
    alias: component_45stub5R9JdsTPRLMeta?.alias || [],
    redirect: component_45stub5R9JdsTPRLMeta?.redirect,
    component: () => import("/var/www/salamis-front-2/node_modules/nuxt/dist/pages/runtime/component-stub").then(m => m.default || m)
  },
  {
    name: component_45stub5R9JdsTPRLMeta?.name ?? undefined,
    path: component_45stub5R9JdsTPRLMeta?.path ?? "/en/en",
    meta: component_45stub5R9JdsTPRLMeta || {},
    alias: component_45stub5R9JdsTPRLMeta?.alias || [],
    redirect: component_45stub5R9JdsTPRLMeta?.redirect,
    component: () => import("/var/www/salamis-front-2/node_modules/nuxt/dist/pages/runtime/component-stub").then(m => m.default || m)
  },
  {
    name: component_45stub5R9JdsTPRLMeta?.name ?? undefined,
    path: component_45stub5R9JdsTPRLMeta?.path ?? "/en/en/about",
    meta: component_45stub5R9JdsTPRLMeta || {},
    alias: component_45stub5R9JdsTPRLMeta?.alias || [],
    redirect: component_45stub5R9JdsTPRLMeta?.redirect,
    component: () => import("/var/www/salamis-front-2/node_modules/nuxt/dist/pages/runtime/component-stub").then(m => m.default || m)
  },
  {
    name: component_45stub5R9JdsTPRLMeta?.name ?? undefined,
    path: component_45stub5R9JdsTPRLMeta?.path ?? "/en/en/events",
    meta: component_45stub5R9JdsTPRLMeta || {},
    alias: component_45stub5R9JdsTPRLMeta?.alias || [],
    redirect: component_45stub5R9JdsTPRLMeta?.redirect,
    component: () => import("/var/www/salamis-front-2/node_modules/nuxt/dist/pages/runtime/component-stub").then(m => m.default || m)
  },
  {
    name: component_45stub5R9JdsTPRLMeta?.name ?? undefined,
    path: component_45stub5R9JdsTPRLMeta?.path ?? "/en/en/policy",
    meta: component_45stub5R9JdsTPRLMeta || {},
    alias: component_45stub5R9JdsTPRLMeta?.alias || [],
    redirect: component_45stub5R9JdsTPRLMeta?.redirect,
    component: () => import("/var/www/salamis-front-2/node_modules/nuxt/dist/pages/runtime/component-stub").then(m => m.default || m)
  },
  {
    name: component_45stub5R9JdsTPRLMeta?.name ?? undefined,
    path: component_45stub5R9JdsTPRLMeta?.path ?? "/en/en/campaigns",
    meta: component_45stub5R9JdsTPRLMeta || {},
    alias: component_45stub5R9JdsTPRLMeta?.alias || [],
    redirect: component_45stub5R9JdsTPRLMeta?.redirect,
    component: () => import("/var/www/salamis-front-2/node_modules/nuxt/dist/pages/runtime/component-stub").then(m => m.default || m)
  },
  {
    name: component_45stub5R9JdsTPRLMeta?.name ?? undefined,
    path: component_45stub5R9JdsTPRLMeta?.path ?? "/en/en/quality",
    meta: component_45stub5R9JdsTPRLMeta || {},
    alias: component_45stub5R9JdsTPRLMeta?.alias || [],
    redirect: component_45stub5R9JdsTPRLMeta?.redirect,
    component: () => import("/var/www/salamis-front-2/node_modules/nuxt/dist/pages/runtime/component-stub").then(m => m.default || m)
  },
  {
    name: component_45stub5R9JdsTPRLMeta?.name ?? undefined,
    path: component_45stub5R9JdsTPRLMeta?.path ?? "/en/en/spa",
    meta: component_45stub5R9JdsTPRLMeta || {},
    alias: component_45stub5R9JdsTPRLMeta?.alias || [],
    redirect: component_45stub5R9JdsTPRLMeta?.redirect,
    component: () => import("/var/www/salamis-front-2/node_modules/nuxt/dist/pages/runtime/component-stub").then(m => m.default || m)
  },
  {
    name: component_45stub5R9JdsTPRLMeta?.name ?? undefined,
    path: component_45stub5R9JdsTPRLMeta?.path ?? "/en/en/gallery",
    meta: component_45stub5R9JdsTPRLMeta || {},
    alias: component_45stub5R9JdsTPRLMeta?.alias || [],
    redirect: component_45stub5R9JdsTPRLMeta?.redirect,
    component: () => import("/var/www/salamis-front-2/node_modules/nuxt/dist/pages/runtime/component-stub").then(m => m.default || m)
  },
  {
    name: component_45stub5R9JdsTPRLMeta?.name ?? undefined,
    path: component_45stub5R9JdsTPRLMeta?.path ?? "/en/en/flavors",
    meta: component_45stub5R9JdsTPRLMeta || {},
    alias: component_45stub5R9JdsTPRLMeta?.alias || [],
    redirect: component_45stub5R9JdsTPRLMeta?.redirect,
    component: () => import("/var/www/salamis-front-2/node_modules/nuxt/dist/pages/runtime/component-stub").then(m => m.default || m)
  },
  {
    name: component_45stub5R9JdsTPRLMeta?.name ?? undefined,
    path: component_45stub5R9JdsTPRLMeta?.path ?? "/new/tr",
    meta: component_45stub5R9JdsTPRLMeta || {},
    alias: component_45stub5R9JdsTPRLMeta?.alias || [],
    redirect: component_45stub5R9JdsTPRLMeta?.redirect,
    component: () => import("/var/www/salamis-front-2/node_modules/nuxt/dist/pages/runtime/component-stub").then(m => m.default || m)
  },
  {
    name: component_45stub5R9JdsTPRLMeta?.name ?? undefined,
    path: component_45stub5R9JdsTPRLMeta?.path ?? "/about-us/",
    meta: component_45stub5R9JdsTPRLMeta || {},
    alias: component_45stub5R9JdsTPRLMeta?.alias || [],
    redirect: component_45stub5R9JdsTPRLMeta?.redirect,
    component: () => import("/var/www/salamis-front-2/node_modules/nuxt/dist/pages/runtime/component-stub").then(m => m.default || m)
  },
  {
    name: component_45stub5R9JdsTPRLMeta?.name ?? undefined,
    path: component_45stub5R9JdsTPRLMeta?.path ?? "/about-us",
    meta: component_45stub5R9JdsTPRLMeta || {},
    alias: component_45stub5R9JdsTPRLMeta?.alias || [],
    redirect: component_45stub5R9JdsTPRLMeta?.redirect,
    component: () => import("/var/www/salamis-front-2/node_modules/nuxt/dist/pages/runtime/component-stub").then(m => m.default || m)
  },
  {
    name: component_45stub5R9JdsTPRLMeta?.name ?? undefined,
    path: component_45stub5R9JdsTPRLMeta?.path ?? "/en/about-us/",
    meta: component_45stub5R9JdsTPRLMeta || {},
    alias: component_45stub5R9JdsTPRLMeta?.alias || [],
    redirect: component_45stub5R9JdsTPRLMeta?.redirect,
    component: () => import("/var/www/salamis-front-2/node_modules/nuxt/dist/pages/runtime/component-stub").then(m => m.default || m)
  },
  {
    name: component_45stub5R9JdsTPRLMeta?.name ?? undefined,
    path: component_45stub5R9JdsTPRLMeta?.path ?? "/en/about-us",
    meta: component_45stub5R9JdsTPRLMeta || {},
    alias: component_45stub5R9JdsTPRLMeta?.alias || [],
    redirect: component_45stub5R9JdsTPRLMeta?.redirect,
    component: () => import("/var/www/salamis-front-2/node_modules/nuxt/dist/pages/runtime/component-stub").then(m => m.default || m)
  },
  {
    name: component_45stub5R9JdsTPRLMeta?.name ?? undefined,
    path: component_45stub5R9JdsTPRLMeta?.path ?? "/cookie-policy",
    meta: component_45stub5R9JdsTPRLMeta || {},
    alias: component_45stub5R9JdsTPRLMeta?.alias || [],
    redirect: component_45stub5R9JdsTPRLMeta?.redirect,
    component: () => import("/var/www/salamis-front-2/node_modules/nuxt/dist/pages/runtime/component-stub").then(m => m.default || m)
  },
  {
    name: component_45stub5R9JdsTPRLMeta?.name ?? undefined,
    path: component_45stub5R9JdsTPRLMeta?.path ?? "/cookie-policy/",
    meta: component_45stub5R9JdsTPRLMeta || {},
    alias: component_45stub5R9JdsTPRLMeta?.alias || [],
    redirect: component_45stub5R9JdsTPRLMeta?.redirect,
    component: () => import("/var/www/salamis-front-2/node_modules/nuxt/dist/pages/runtime/component-stub").then(m => m.default || m)
  },
  {
    name: component_45stub5R9JdsTPRLMeta?.name ?? undefined,
    path: component_45stub5R9JdsTPRLMeta?.path ?? "/image/grand-deluxe-room/",
    meta: component_45stub5R9JdsTPRLMeta || {},
    alias: component_45stub5R9JdsTPRLMeta?.alias || [],
    redirect: component_45stub5R9JdsTPRLMeta?.redirect,
    component: () => import("/var/www/salamis-front-2/node_modules/nuxt/dist/pages/runtime/component-stub").then(m => m.default || m)
  },
  {
    name: component_45stub5R9JdsTPRLMeta?.name ?? undefined,
    path: component_45stub5R9JdsTPRLMeta?.path ?? "/image/grand-deluxe-room",
    meta: component_45stub5R9JdsTPRLMeta || {},
    alias: component_45stub5R9JdsTPRLMeta?.alias || [],
    redirect: component_45stub5R9JdsTPRLMeta?.redirect,
    component: () => import("/var/www/salamis-front-2/node_modules/nuxt/dist/pages/runtime/component-stub").then(m => m.default || m)
  },
  {
    name: component_45stub5R9JdsTPRLMeta?.name ?? undefined,
    path: component_45stub5R9JdsTPRLMeta?.path ?? "/image/monalisa-restaurant-5/",
    meta: component_45stub5R9JdsTPRLMeta || {},
    alias: component_45stub5R9JdsTPRLMeta?.alias || [],
    redirect: component_45stub5R9JdsTPRLMeta?.redirect,
    component: () => import("/var/www/salamis-front-2/node_modules/nuxt/dist/pages/runtime/component-stub").then(m => m.default || m)
  },
  {
    name: component_45stub5R9JdsTPRLMeta?.name ?? undefined,
    path: component_45stub5R9JdsTPRLMeta?.path ?? "/image/monalisa-restaurant-5",
    meta: component_45stub5R9JdsTPRLMeta || {},
    alias: component_45stub5R9JdsTPRLMeta?.alias || [],
    redirect: component_45stub5R9JdsTPRLMeta?.redirect,
    component: () => import("/var/www/salamis-front-2/node_modules/nuxt/dist/pages/runtime/component-stub").then(m => m.default || m)
  },
  {
    name: component_45stub5R9JdsTPRLMeta?.name ?? undefined,
    path: component_45stub5R9JdsTPRLMeta?.path ?? "/events/meetings",
    meta: component_45stub5R9JdsTPRLMeta || {},
    alias: component_45stub5R9JdsTPRLMeta?.alias || [],
    redirect: component_45stub5R9JdsTPRLMeta?.redirect,
    component: () => import("/var/www/salamis-front-2/node_modules/nuxt/dist/pages/runtime/component-stub").then(m => m.default || m)
  },
  {
    name: component_45stub5R9JdsTPRLMeta?.name ?? undefined,
    path: component_45stub5R9JdsTPRLMeta?.path ?? "/events/meetings/",
    meta: component_45stub5R9JdsTPRLMeta || {},
    alias: component_45stub5R9JdsTPRLMeta?.alias || [],
    redirect: component_45stub5R9JdsTPRLMeta?.redirect,
    component: () => import("/var/www/salamis-front-2/node_modules/nuxt/dist/pages/runtime/component-stub").then(m => m.default || m)
  },
  {
    name: component_45stub5R9JdsTPRLMeta?.name ?? undefined,
    path: component_45stub5R9JdsTPRLMeta?.path ?? "/events/organizations",
    meta: component_45stub5R9JdsTPRLMeta || {},
    alias: component_45stub5R9JdsTPRLMeta?.alias || [],
    redirect: component_45stub5R9JdsTPRLMeta?.redirect,
    component: () => import("/var/www/salamis-front-2/node_modules/nuxt/dist/pages/runtime/component-stub").then(m => m.default || m)
  },
  {
    name: component_45stub5R9JdsTPRLMeta?.name ?? undefined,
    path: component_45stub5R9JdsTPRLMeta?.path ?? "/events/organizations/",
    meta: component_45stub5R9JdsTPRLMeta || {},
    alias: component_45stub5R9JdsTPRLMeta?.alias || [],
    redirect: component_45stub5R9JdsTPRLMeta?.redirect,
    component: () => import("/var/www/salamis-front-2/node_modules/nuxt/dist/pages/runtime/component-stub").then(m => m.default || m)
  },
  {
    name: component_45stub5R9JdsTPRLMeta?.name ?? undefined,
    path: component_45stub5R9JdsTPRLMeta?.path ?? "/index",
    meta: component_45stub5R9JdsTPRLMeta || {},
    alias: component_45stub5R9JdsTPRLMeta?.alias || [],
    redirect: component_45stub5R9JdsTPRLMeta?.redirect,
    component: () => import("/var/www/salamis-front-2/node_modules/nuxt/dist/pages/runtime/component-stub").then(m => m.default || m)
  },
  {
    name: component_45stub5R9JdsTPRLMeta?.name ?? undefined,
    path: component_45stub5R9JdsTPRLMeta?.path ?? "/index/",
    meta: component_45stub5R9JdsTPRLMeta || {},
    alias: component_45stub5R9JdsTPRLMeta?.alias || [],
    redirect: component_45stub5R9JdsTPRLMeta?.redirect,
    component: () => import("/var/www/salamis-front-2/node_modules/nuxt/dist/pages/runtime/component-stub").then(m => m.default || m)
  },
  {
    name: component_45stub5R9JdsTPRLMeta?.name ?? undefined,
    path: component_45stub5R9JdsTPRLMeta?.path ?? "/index.php/en/our-services/spa-2",
    meta: component_45stub5R9JdsTPRLMeta || {},
    alias: component_45stub5R9JdsTPRLMeta?.alias || [],
    redirect: component_45stub5R9JdsTPRLMeta?.redirect,
    component: () => import("/var/www/salamis-front-2/node_modules/nuxt/dist/pages/runtime/component-stub").then(m => m.default || m)
  },
  {
    name: component_45stub5R9JdsTPRLMeta?.name ?? undefined,
    path: component_45stub5R9JdsTPRLMeta?.path ?? "/index.fcgi/tr/about-us/",
    meta: component_45stub5R9JdsTPRLMeta || {},
    alias: component_45stub5R9JdsTPRLMeta?.alias || [],
    redirect: component_45stub5R9JdsTPRLMeta?.redirect,
    component: () => import("/var/www/salamis-front-2/node_modules/nuxt/dist/pages/runtime/component-stub").then(m => m.default || m)
  },
  {
    name: component_45stub5R9JdsTPRLMeta?.name ?? undefined,
    path: component_45stub5R9JdsTPRLMeta?.path ?? "/index.fcgi/tr/events/weddings/dugun/",
    meta: component_45stub5R9JdsTPRLMeta || {},
    alias: component_45stub5R9JdsTPRLMeta?.alias || [],
    redirect: component_45stub5R9JdsTPRLMeta?.redirect,
    component: () => import("/var/www/salamis-front-2/node_modules/nuxt/dist/pages/runtime/component-stub").then(m => m.default || m)
  },
  {
    name: component_45stub5R9JdsTPRLMeta?.name ?? undefined,
    path: component_45stub5R9JdsTPRLMeta?.path ?? "/index.fcgi/tr/events/weddings/dugun",
    meta: component_45stub5R9JdsTPRLMeta || {},
    alias: component_45stub5R9JdsTPRLMeta?.alias || [],
    redirect: component_45stub5R9JdsTPRLMeta?.redirect,
    component: () => import("/var/www/salamis-front-2/node_modules/nuxt/dist/pages/runtime/component-stub").then(m => m.default || m)
  },
  {
    name: component_45stub5R9JdsTPRLMeta?.name ?? undefined,
    path: component_45stub5R9JdsTPRLMeta?.path ?? "/index.php/en/casino",
    meta: component_45stub5R9JdsTPRLMeta || {},
    alias: component_45stub5R9JdsTPRLMeta?.alias || [],
    redirect: component_45stub5R9JdsTPRLMeta?.redirect,
    component: () => import("/var/www/salamis-front-2/node_modules/nuxt/dist/pages/runtime/component-stub").then(m => m.default || m)
  },
  {
    name: component_45stub5R9JdsTPRLMeta?.name ?? undefined,
    path: component_45stub5R9JdsTPRLMeta?.path ?? "/index.php/en",
    meta: component_45stub5R9JdsTPRLMeta || {},
    alias: component_45stub5R9JdsTPRLMeta?.alias || [],
    redirect: component_45stub5R9JdsTPRLMeta?.redirect,
    component: () => import("/var/www/salamis-front-2/node_modules/nuxt/dist/pages/runtime/component-stub").then(m => m.default || m)
  },
  {
    name: component_45stub5R9JdsTPRLMeta?.name ?? undefined,
    path: component_45stub5R9JdsTPRLMeta?.path ?? "/index.php/tr/iletisim",
    meta: component_45stub5R9JdsTPRLMeta || {},
    alias: component_45stub5R9JdsTPRLMeta?.alias || [],
    redirect: component_45stub5R9JdsTPRLMeta?.redirect,
    component: () => import("/var/www/salamis-front-2/node_modules/nuxt/dist/pages/runtime/component-stub").then(m => m.default || m)
  },
  {
    name: component_45stub5R9JdsTPRLMeta?.name ?? undefined,
    path: component_45stub5R9JdsTPRLMeta?.path ?? "/index.php/ru/",
    meta: component_45stub5R9JdsTPRLMeta || {},
    alias: component_45stub5R9JdsTPRLMeta?.alias || [],
    redirect: component_45stub5R9JdsTPRLMeta?.redirect,
    component: () => import("/var/www/salamis-front-2/node_modules/nuxt/dist/pages/runtime/component-stub").then(m => m.default || m)
  },
  {
    name: component_45stub5R9JdsTPRLMeta?.name ?? undefined,
    path: component_45stub5R9JdsTPRLMeta?.path ?? "/index.php/ru",
    meta: component_45stub5R9JdsTPRLMeta || {},
    alias: component_45stub5R9JdsTPRLMeta?.alias || [],
    redirect: component_45stub5R9JdsTPRLMeta?.redirect,
    component: () => import("/var/www/salamis-front-2/node_modules/nuxt/dist/pages/runtime/component-stub").then(m => m.default || m)
  },
  {
    name: component_45stub5R9JdsTPRLMeta?.name ?? undefined,
    path: component_45stub5R9JdsTPRLMeta?.path ?? "/rooms/standart-room",
    meta: component_45stub5R9JdsTPRLMeta || {},
    alias: component_45stub5R9JdsTPRLMeta?.alias || [],
    redirect: component_45stub5R9JdsTPRLMeta?.redirect,
    component: () => import("/var/www/salamis-front-2/node_modules/nuxt/dist/pages/runtime/component-stub").then(m => m.default || m)
  },
  {
    name: component_45stub5R9JdsTPRLMeta?.name ?? undefined,
    path: component_45stub5R9JdsTPRLMeta?.path ?? "/rooms/park-room",
    meta: component_45stub5R9JdsTPRLMeta || {},
    alias: component_45stub5R9JdsTPRLMeta?.alias || [],
    redirect: component_45stub5R9JdsTPRLMeta?.redirect,
    component: () => import("/var/www/salamis-front-2/node_modules/nuxt/dist/pages/runtime/component-stub").then(m => m.default || m)
  },
  {
    name: component_45stub5R9JdsTPRLMeta?.name ?? undefined,
    path: component_45stub5R9JdsTPRLMeta?.path ?? "/rooms/superior-villa",
    meta: component_45stub5R9JdsTPRLMeta || {},
    alias: component_45stub5R9JdsTPRLMeta?.alias || [],
    redirect: component_45stub5R9JdsTPRLMeta?.redirect,
    component: () => import("/var/www/salamis-front-2/node_modules/nuxt/dist/pages/runtime/component-stub").then(m => m.default || m)
  },
  {
    name: component_45stub5R9JdsTPRLMeta?.name ?? undefined,
    path: component_45stub5R9JdsTPRLMeta?.path ?? "/en/rooms/standart-room",
    meta: component_45stub5R9JdsTPRLMeta || {},
    alias: component_45stub5R9JdsTPRLMeta?.alias || [],
    redirect: component_45stub5R9JdsTPRLMeta?.redirect,
    component: () => import("/var/www/salamis-front-2/node_modules/nuxt/dist/pages/runtime/component-stub").then(m => m.default || m)
  },
  {
    name: component_45stub5R9JdsTPRLMeta?.name ?? undefined,
    path: component_45stub5R9JdsTPRLMeta?.path ?? "/en/rooms/park-room",
    meta: component_45stub5R9JdsTPRLMeta || {},
    alias: component_45stub5R9JdsTPRLMeta?.alias || [],
    redirect: component_45stub5R9JdsTPRLMeta?.redirect,
    component: () => import("/var/www/salamis-front-2/node_modules/nuxt/dist/pages/runtime/component-stub").then(m => m.default || m)
  },
  {
    name: component_45stub5R9JdsTPRLMeta?.name ?? undefined,
    path: component_45stub5R9JdsTPRLMeta?.path ?? "/en/rooms/superior-villa",
    meta: component_45stub5R9JdsTPRLMeta || {},
    alias: component_45stub5R9JdsTPRLMeta?.alias || [],
    redirect: component_45stub5R9JdsTPRLMeta?.redirect,
    component: () => import("/var/www/salamis-front-2/node_modules/nuxt/dist/pages/runtime/component-stub").then(m => m.default || m)
  },
  {
    name: component_45stub5R9JdsTPRLMeta?.name ?? undefined,
    path: component_45stub5R9JdsTPRLMeta?.path ?? "/en/blog/kibrista-gezilecek-en-iyi-yerler",
    meta: component_45stub5R9JdsTPRLMeta || {},
    alias: component_45stub5R9JdsTPRLMeta?.alias || [],
    redirect: component_45stub5R9JdsTPRLMeta?.redirect,
    component: () => import("/var/www/salamis-front-2/node_modules/nuxt/dist/pages/runtime/component-stub").then(m => m.default || m)
  },
  {
    name: component_45stub5R9JdsTPRLMeta?.name ?? undefined,
    path: component_45stub5R9JdsTPRLMeta?.path ?? "/en/blog/kuzey-kibrisa-nasil-gidilir",
    meta: component_45stub5R9JdsTPRLMeta || {},
    alias: component_45stub5R9JdsTPRLMeta?.alias || [],
    redirect: component_45stub5R9JdsTPRLMeta?.redirect,
    component: () => import("/var/www/salamis-front-2/node_modules/nuxt/dist/pages/runtime/component-stub").then(m => m.default || m)
  },
  {
    name: component_45stub5R9JdsTPRLMeta?.name ?? undefined,
    path: component_45stub5R9JdsTPRLMeta?.path ?? "/en/blog/kibrista-gunbatimi-izlenecek-yerler",
    meta: component_45stub5R9JdsTPRLMeta || {},
    alias: component_45stub5R9JdsTPRLMeta?.alias || [],
    redirect: component_45stub5R9JdsTPRLMeta?.redirect,
    component: () => import("/var/www/salamis-front-2/node_modules/nuxt/dist/pages/runtime/component-stub").then(m => m.default || m)
  },
  {
    name: component_45stub5R9JdsTPRLMeta?.name ?? undefined,
    path: component_45stub5R9JdsTPRLMeta?.path ?? "/en/blog/kibrista-fotograf-cekilecek-yerler",
    meta: component_45stub5R9JdsTPRLMeta || {},
    alias: component_45stub5R9JdsTPRLMeta?.alias || [],
    redirect: component_45stub5R9JdsTPRLMeta?.redirect,
    component: () => import("/var/www/salamis-front-2/node_modules/nuxt/dist/pages/runtime/component-stub").then(m => m.default || m)
  },
  {
    name: component_45stub5R9JdsTPRLMeta?.name ?? undefined,
    path: component_45stub5R9JdsTPRLMeta?.path ?? "/en/blog/salamis-harabeleri-gezi-rehberi",
    meta: component_45stub5R9JdsTPRLMeta || {},
    alias: component_45stub5R9JdsTPRLMeta?.alias || [],
    redirect: component_45stub5R9JdsTPRLMeta?.redirect,
    component: () => import("/var/www/salamis-front-2/node_modules/nuxt/dist/pages/runtime/component-stub").then(m => m.default || m)
  },
  {
    name: component_45stub5R9JdsTPRLMeta?.name ?? undefined,
    path: component_45stub5R9JdsTPRLMeta?.path ?? "/en/blog/soli-antik-kenti",
    meta: component_45stub5R9JdsTPRLMeta || {},
    alias: component_45stub5R9JdsTPRLMeta?.alias || [],
    redirect: component_45stub5R9JdsTPRLMeta?.redirect,
    component: () => import("/var/www/salamis-front-2/node_modules/nuxt/dist/pages/runtime/component-stub").then(m => m.default || m)
  },
  {
    name: component_45stub5R9JdsTPRLMeta?.name ?? undefined,
    path: component_45stub5R9JdsTPRLMeta?.path ?? "/blog/best-time-to-visit-cyprus",
    meta: component_45stub5R9JdsTPRLMeta || {},
    alias: component_45stub5R9JdsTPRLMeta?.alias || [],
    redirect: component_45stub5R9JdsTPRLMeta?.redirect,
    component: () => import("/var/www/salamis-front-2/node_modules/nuxt/dist/pages/runtime/component-stub").then(m => m.default || m)
  },
  {
    name: component_45stub5R9JdsTPRLMeta?.name ?? undefined,
    path: component_45stub5R9JdsTPRLMeta?.path ?? "/blog/soli-ancient-city",
    meta: component_45stub5R9JdsTPRLMeta || {},
    alias: component_45stub5R9JdsTPRLMeta?.alias || [],
    redirect: component_45stub5R9JdsTPRLMeta?.redirect,
    component: () => import("/var/www/salamis-front-2/node_modules/nuxt/dist/pages/runtime/component-stub").then(m => m.default || m)
  },
  {
    name: component_45stub5R9JdsTPRLMeta?.name ?? undefined,
    path: component_45stub5R9JdsTPRLMeta?.path ?? "/blog/photogenic-places-in-cyprus",
    meta: component_45stub5R9JdsTPRLMeta || {},
    alias: component_45stub5R9JdsTPRLMeta?.alias || [],
    redirect: component_45stub5R9JdsTPRLMeta?.redirect,
    component: () => import("/var/www/salamis-front-2/node_modules/nuxt/dist/pages/runtime/component-stub").then(m => m.default || m)
  },
  {
    name: component_45stub5R9JdsTPRLMeta?.name ?? undefined,
    path: component_45stub5R9JdsTPRLMeta?.path ?? "/blog/cyprus-bays",
    meta: component_45stub5R9JdsTPRLMeta || {},
    alias: component_45stub5R9JdsTPRLMeta?.alias || [],
    redirect: component_45stub5R9JdsTPRLMeta?.redirect,
    component: () => import("/var/www/salamis-front-2/node_modules/nuxt/dist/pages/runtime/component-stub").then(m => m.default || m)
  }
]